import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { NuqsAdapter } from "nuqs/adapters/react";

import { PostHogProvider } from "posthog-js/react";
import * as Sentry from "@sentry/react";

if (import.meta.env.MODE === "production") {
  Sentry.init({
    dsn: "https://8696d441bc7c11a48f9bad4f859831c5@o4509282163228672.ingest.de.sentry.io/4509282169323600",
    sendDefaultPii: true,
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
        debug: import.meta.env.MODE === "development",
      }}
    >
      <NuqsAdapter>
        <App />
      </NuqsAdapter>
    </PostHogProvider>
  </React.StrictMode>
);
